import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import TicketHeaderActions from './SubComponents/TicketHeaderActions';
import TicketHeaderInfo from './SubComponents/TicketHeaderInfo';

interface Props {
    ticketKey: TicketKey;
}

const TicketHeader = ({ ticketKey }: Props) => (
    <div
        className="@container flex grow items-center justify-between gap-x-3"
        key={`header-${ticketKey}`}
    >
        <TicketHeaderInfo ticketKey={ticketKey} />
        <TicketHeaderActions ticketKey={ticketKey} />
    </div>
);

export default React.memo(TicketHeader);
